const request = {
    message_rate_limited: 'پیام‌های زیادی به این گیرنده ارسال شده است. لطفاً بعداً تلاش کنید.',
    invalid_input: 'ورودی نامعتبر است. {{details}}',
    general: 'خطای درخواست رخ داد.',
    range_not_satisfiable: 'بازه قابل برآورده‌سازی نیست.',
    feature_not_supported: 'این ویژگی در محیط فعلی پشتیبانی نمی‌شود.',
    rate_limited: 'درخواست‌های بیش از حد. لطفاً بعداً دوباره تلاش کنید.',
};
export default Object.freeze(request);
